import { render } from "./AdminFeesView.vue?vue&type=template&id=1fc7b0e6&scoped=true"
import script from "./AdminFeesView.vue?vue&type=script&lang=js"
export * from "./AdminFeesView.vue?vue&type=script&lang=js"

import "./AdminFeesView.vue?vue&type=style&index=0&id=1fc7b0e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc7b0e6"]])

export default __exports__